
<template>
  <div>
    <v-container>
      <div class="text-center background text border pt-2 pb-2">
        <div class="text-center mr-5 ml-5 mt-4">
          <h4>Select option</h4>
          <!-- <small>Select search option</small> -->
          <hr />
        </div>

        <div>
          <div class="d-flex justify-content-center">
            <div class="mt-3" style="width: 60%">
              <div class="pb-3">From</div>
              <v-select
                @change="setWorldFrom"
                :items="worlds"
                label="Choose world..."
                solo
              >
                <template v-slot:[`item`]="{ item }">
                  <div>{{ item }} ({{ worldsMetaData[item].pvpType }})</div>
                </template>
              </v-select>

              <div class="pb-3">to</div>
              <v-select
                @change="setWorldTo"
                :items="worlds"
                label="Choose world..."
                solo
              >
                <template v-slot:[`item`]="{ item }">
                  <div>{{ item }} ({{ worldsMetaData[item].pvpType }})</div>
                </template>
              </v-select>
            </div>
          </div>
          <v-btn @click="getWorldsItems({ from: worldFrom, to: worldTo })">
            Search
          </v-btn>
        </div>
      </div>
    </v-container>
  </div>
</template>



<script>
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      optionSelected: "bg-secondary",
      option: "world",
    };
  },
  computed: {
    ...mapState(["worlds", "worldFrom", "worldTo", "worldsMetaData"]),
  },
  methods: {
    ...mapMutations([
      "getWorldsItems",
      "selectedWorld",
      "setWorldFrom",
      "setWorldTo",
    ]),
    selectedWorldFrom(world) {
      console.log(world);
    },
    selectedWorldTo(world) {
      console.log(world);
    },
  },
};
</script>


<style scoped>
.background {
  background-color: rgb(12, 25, 32);
}

.text {
  color: rgb(238, 195, 147);
}

.border {
  border-radius: 10px;
  border-width: 2px;
  border-color: white;
}

.hoverable {
  border-radius: 10px;
}

.hoverable:hover {
  cursor: pointer;
  border-radius: 10px;
  background-color: rgb(60, 60, 60);
}
</style>